<template>
    <div>
        <!-- Header -->
        <div class="clearfix row py-2 mb-2 mt-5 no-margin border-bottom">
            <div class="col-sm-6 text-left pl-0">
                <h5 class="mb-0">Compensatory Leave List (Applied)</h5>
            </div>
            <div class="col-sm-6 text-right pr-0">
                <b-button v-if="ce" @click="addNew">+ Add New</b-button>
            </div>
        </div>

        <!-- Table -->
        <div class="row justify-content-center no-margin">
            <div class="col-sm-12 px-0">
                <b-overlay :show="showoverlay_list" rounded="sm">
                    <table class="table dataTable border">
                        <thead>
                            <tr class="table-head">
                                <td>Employee</td>
                                <td>Job Position</td>
                                <td>Department</td>
                                <td>Leave Date</td>
                                <td>Used Attendance Date</td>
                                <td>Reason</td>
                                <td class="text-right" v-if="ce">Action</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(leave, index) in leaves" :key="index">
                                <td>
                                    <div class="img-holder">
                                        <img v-if="leave.employee_pic"
                                            :src="`/avatar/${leave.company_id}/${leave.employee_pic}`"
                                            class="img-fluid img-thumbnail employee-avatar mr-2" />
                                        <img v-else src="/avatar/demo.jpg"
                                            class="img-fluid img-thumbnail employee-avatar mx-2" />
                                    </div>
                                    <div class="name-holder">
                                        {{ leave.employee_name }}<br />
                                        <span class="txt-alt">{{ leave.employee_code }}</span>
                                    </div>
                                </td>
                                <td>{{ leave.jobposition_name }}</td>
                                <td>{{ leave.department_name }}</td>
                                <td>{{ leave.leave_date }}</td>
                                <td>{{ leave.attendance_date }}</td>
                                <td>{{ leave.reason }}</td>
                                <td class="position-relative text-right" v-if="ce">
                                    <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle"
                                        style="font-size: 16px;" href="#" role="button" data-toggle="dropdown"
                                        aria-haspopup="true" aria-expanded="false"><b-icon
                                            icon="three-dots-vertical"></b-icon></a>
                                    <div class="dropdown-menu action-dropdown-menu w-200 px-1"
                                        aria-labelledby="actionDropdown">
                                        <b-button-group class="mr-0">
                                            <b-button class="mr-3 rounded edit-btn text-left" title="Edit Work Location"
                                                @click="updateLeave(leave.id, 1)">
                                                <b-icon icon="check" class="mr-2" aria-hidden="true"></b-icon>Approve
                                            </b-button>

                                            <b-button class="mr-3 rounded edit-btn text-left" title="Edit Work Location"
                                                @click="updateLeave(leave.id, 2)">
                                                <b-icon icon="x" class="mr-2" aria-hidden="true"></b-icon>Reject
                                            </b-button>
                                        </b-button-group>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div v-if="leaves.length === 0" class="list-no-data">No records found.</div>
                </b-overlay>
            </div>
        </div>

        <b-modal id="bv-modal-add-compensatory-leave" size="xl" scrollable hide-footer title="Add Compensatory Leave"
            @hidden="onAddModalClose">
            <l-a-compensatory-leaves-employee-list v-if="employee_id == 0" :flg="1"
                v-on:childToParent="setEmployee"></l-a-compensatory-leaves-employee-list>

            <l-a-compensatory-leaves-employee-leave-details v-if="employee_id > 0" :employee_id="employee_id"
                v-on:childToParent="handleEvent"></l-a-compensatory-leaves-employee-leave-details>
        </b-modal>

    </div>
</template>

<script>
export default {
    data() {
        return {
            leaves: [],
            showoverlay_list: false,
            ce: true,
            employee_id: 0,
        };
    },
    created: function () {
        this.getLeaves();
    },
    methods: {
        getLeaves() {
            this.showoverlay_list = true;
            axios
                .get(this.$api_url + '/company-compensatory-leave-list?status=0')
                .then((response) => {
                    this.leaves = response.data;
                    this.showoverlay_list = false;
                })
                .catch((err) => {
                    console.error('Error fetching leaves:', err);
                    this.leaves = [];
                    this.showoverlay_list = false;
                });
        },
        addNew() {
            this.$bvModal.show('bv-modal-add-compensatory-leave');
        },
        editLeave() {
            console.log('Edit leave');
        },
        updateLeave(id, status) {
            this.showoverlay = true;

            let formData = new FormData();
            formData.append('id', id);
            formData.append('status', status);

            axios.post(this.$api_url + '/compensatory-leave-update', formData)
                .then(response => {
                    this.$bvToast.toast(response.data.message || 'Saved successfully.', {
                        title: 'Success',
                        variant: 'success',
                        solid: true
                    });

                    this.getLeaves();
                    this.$emit('childToParent');
                    this.$emit('updateList', { status: status });
                })
                .catch(error => {
                    const message =
                        error.response && error.response.data && error.response.data.message
                            ? error.response.data.message
                            : 'An unexpected error occurred.';

                    this.$bvToast.toast(message, {
                        title: 'Error',
                        variant: 'danger',
                        solid: true
                    });
                })
                .finally(() => {
                    this.showoverlay = false;
                });
        },
        setEmployee: function (data) {
            this.employee_id = data.employee_id;
        },
        onAddModalClose() {
            this.employee_id = 0;
        },
        handleEvent : function(data) {
            this.getLeaves();
            this.$emit('updateList', { status: 1 });
            this.$emit('updateList', { status: 2 });
        }
    },
};
</script>

<style scoped>
.img-holder {
    cursor: not-allowed;
    pointer-events: none;
}

.employee-avatar {
    width: 40px;
    height: 40px;
}

.table-head {
    font-weight: bold;
}
</style>
